// Pure helpers for the Depot select (staff distance-origin override, ADR-0011)
// and the depot-aware distance surfaces. Kept DOM-free so they can be
// unit-tested; application.js does the actual DOM reads/writes.

// Whether a depot option is selectable given the pricing state and forced
// SA-direct status. `option` needs { value, unitMode }. Rules:
//   - the Auto option (blank value) is always selectable;
//   - forced SA-direct locks the whole SELECT (not individual options), so no
//     option is individually disabled while forced;
//   - a non-forced VIC order prices by HOURS from the hours depot, so km-mode
//     depots are disabled — a km figure must never feed FLAT hours pricing.
export function depotOptionDisabled(option, { state, forced }) {
  if (!option.value) return false
  return !forced && state === 'VIC' && option.unitMode !== 'hours'
}

// Unit shown by the derived caption: hours only for a non-forced VIC order
// whose origin is Auto (chosenUnitMode == null) or an hours-mode depot.
export function captionUnit({ state, forced, chosenUnitMode }) {
  const hoursOrigin = chosenUnitMode == null || chosenUnitMode === 'hours'
  return state === 'VIC' && !forced && hoursOrigin ? 'hrs' : 'km'
}

// Which of the lookup response's surfaces the contact-distance line shows: the
// sa_direct candidate when forced (ADR-0010), else the primary. The suffix is
// the DEPOT's own state — never the customer's pricing state, which once
// produced lies like "Cranbourne Holding Yard (NSW)" — and is omitted when the
// response carries no depot_state.
export function contactDistanceParts(data, forced) {
  const src = forced && data.sa_direct ? data.sa_direct : data
  const unit = src.unit === 'hours' ? 'hrs' : src.unit
  const suffix = src.depot_state ? ` (${src.depot_state})` : ''
  return { value: src.value, depot: src.depot, unit, suffix }
}
